import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import styled from 'styled-components';
import { theme } from './theme';
import { GlobalStyle } from './theme/globalStyles';
import './App.css';
import { Navigation } from './components/navigation';
import { Footer } from './components/layout/Footer';
import {
    HomePage,
    AudioPage,
    VideoPage,
    ImagesPage,
    StoryPage,
    ContactPage,
    ShowsPage,
} from './pages';

const AppContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`;

const MainContent = styled.main`
    flex: 1;
`;

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

function App(): React.ReactElement {
    return (
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <GlobalStyle theme={theme} />
                <ScrollToTop />
                <AppContainer>
                    <Navigation />
                    <MainContent>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/albums" element={<AudioPage />} />
                            <Route path="/videos" element={<VideoPage />} />
                            <Route path="/gallery" element={<ImagesPage />} />
                            <Route path="/shows" element={<ShowsPage />} />
                            <Route path="/story" element={<StoryPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                        </Routes>
                    </MainContent>
                    <Footer />
                </AppContainer>
            </ThemeProvider>
        </BrowserRouter>
    );
}

export default App;
